import { isDevelopment } from '../../../config/env-checks'

export function hotModuleReload(allEnviroments = false) {
  if ((allEnviroments || isDevelopment) && typeof module.hot !== 'undefined') {
    module.hot.accept() // eslint-disable-line no-undef
  }
}
